module.exports = __webpack_public_path__ + "img/CM-JRF-25-GMC-Modern.e0fb41b3.jpg";